module.exports = __webpack_public_path__ + "static/img/bg-fr.c29381e9.png";